"use client"

import * as React from "react"
import { DayPicker } from "react-day-picker"
import { cn } from "../../utils/utils"
import { buttonVariants } from "./button"
import { enUS } from "date-fns/locale"



export type CalendarProps = React.ComponentProps<typeof DayPicker>

function Calendar({
  className,
  classNames,
  showOutsideDays = true,
  ...props
}: CalendarProps) {
  return (
    <div className="w-auto h-auto">
    <DayPicker
      showOutsideDays={showOutsideDays}
      weekStartsOn={0} // Start week on Sunday
      firstWeekContainsDate={1} // First week includes the 1st of the month 
      locale={enUS}
      className={cn("p-3", className)}
      classNames={{
        months: "flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0",
        month: "space-y-2 w-[280px] min-w-[280px]",
        month_grid:"w-full !important",
        weekdays: "w-full grid grid-cols-7 gap-0 !important",
        weekday:"text-muted-foreground font-medium text-center text-s w-[14.2857%] min-w-[42px] max-w-[14.2857%] box-border p-0 m-0 !important",
        week: "w-full grid grid-cols-7 gap-0 mt-1 !important",
        caption: "flex justify-center pt-1 relative items-center min-w-[160px]",
        caption_label: "text-sm font-medium text-center mx-auto w-full",
        nav: "space-x-1 flex justify-between items-center z-10 pointer-events-auto",
        nav_button: cn(
          buttonVariants({ variant: "link" }),
          "h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100"
        ),
        button_previous: "absolute left-2 top-48 [var(--chart-text)]",
        button_next: "absolute right-2 top-48",
        chevron:"fill-[var(--chart-text)]",
        table: "w-full border-collapse",
        row: "flex w-full mt-2",
        cell:"h-9 w-[14.2857%] min-w-[42px] max-w-[14.2857%] text-center text-sm p-0 m-0 relative box-border",
        day: cn(
          buttonVariants({ variant: "ghost" }),
          "h-9 w-9 p-0 font-normal aria-selected:opacity-100 "
        ),
        day_range_end: "day-range-end",
        day_selected:
          "bg-primary text-primary-foreground hover:bg-primary hover:text-primary-foreground focus:bg-primary focus:text-primary-foreground",
        day_today: "bg-accent text-accent-foreground",
        day_outside:
          "day-outside text-muted-foreground aria-selected:bg-accent/50 aria-selected:text-muted-foreground",
        day_disabled: "text-muted-foreground opacity-50",
        day_range_middle:
          "aria-selected:bg-accent aria-selected:text-accent-foreground",
        day_hidden: "invisible",
        ...classNames,
      }}
      
      
      {...props}
    />
    </div>
  )
}

Calendar.displayName = "Calendar"

export { Calendar }
